import { LANGUAGE } from '@src/constants';

const formatCommasThousand = (number) =>
  Number(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

const delimitNumber = (number, lang = LANGUAGE.VN) => {
  const delimiter = lang === LANGUAGE.VN ? '.' : ',';
  if (number)
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
  return 0;
};

const SI_PREFIXES = [
  { value: 1, symbol: '' },
  { value: 1e3, symbol: 'k' },
  { value: 1e6, symbol: 'M' },
  { value: 1e9, symbol: 'G' },
  { value: 1e12, symbol: 'T' },
  { value: 1e15, symbol: 'P' },
  { value: 1e18, symbol: 'E' },
];

const abbreviateNumber = (number) => {
  if (number === 0) return number;

  const tier = SI_PREFIXES.filter((n) => number >= n.value).pop();
  const numberFixed = (number / tier.value).toFixed(1);

  return `${numberFixed}${tier.symbol}`;
};

const validateNumber = (number) => {
  const NUMBER_REGEX = /^[0-9]+(\.[0-9]+)?$/;
  return NUMBER_REGEX.test(number);
};

const getRandomIntNumber = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const checkIsNumber = (number) => {
  const NUMBER_REGEX = /^[0-9]+(\.[0-9]+)?$/;
  return NUMBER_REGEX.test(number);
};

const formatPhoneNumber = (rawPhoneNumber) => {
  // Format the phone number as per your requirement
  const formattedPhoneNumber = rawPhoneNumber.replace(
    /(\d{4})(\d{3})(\d{3})/,
    '$1 $2 $3',
  );
  return formattedPhoneNumber;
};

const twoDigitNumber = (num) => (num < 10 ? `0${num}` : num.toString());

const roundTo9000 = (amount) => {
  if (amount <= 0) return 0;
  const remainder = amount % 10000;
  return remainder < 5000
    ? amount - remainder - 1000
    : amount + 9000 - remainder;
};

const roundToNearest0Point9 = (amount) => {
  if (amount <= 0) return 0;
  const remainder = amount % 1;
  const number =
    remainder < 0.5 ? amount - remainder - 0.1 : amount + 0.9 - remainder;

  return Math.round(number * 10) / 10;
};

const formatNumber = (number, language) =>
  Number(number)?.toLocaleString(language);

const roundNumber = (value, decimals = 0) => {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
};

const formatNumberWithSuffix = (num, language = LANGUAGE.VN) => {
  const suffixes = {
    [LANGUAGE.VN]: {
      K: 'N',
      M: 'Tr',
      B: 'Tỷ',
    },
    [LANGUAGE.EN]: {
      K: 'K',
      M: 'M',
      B: 'B',
    },
  };

  const format = (value, suffix) =>
    `${value.toLocaleString(language, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    })}${language === LANGUAGE.VN ? ` ${suffix}` : suffix}`;

  if (num >= 1e9) return format(num / 1e9, suffixes[language].B);
  if (num >= 1e6) return format(num / 1e6, suffixes[language].M);
  if (num >= 1e3) return format(num / 1e3, suffixes[language].K);
  return num.toString();
};

const replaceNumberWithDot = (value) => {
  let newValue = value;
  newValue = newValue.replace(/[^0-9.]/g, '');
  newValue = newValue.replace(/(\..?)\../g, '$1');
  return newValue;
};

export {
  formatNumber,
  roundTo9000,
  roundToNearest0Point9,
  formatCommasThousand,
  delimitNumber,
  abbreviateNumber,
  validateNumber,
  getRandomIntNumber,
  checkIsNumber,
  formatPhoneNumber,
  twoDigitNumber,
  roundNumber,
  formatNumberWithSuffix,
  replaceNumberWithDot,
};
